/**
 * Hook pour tracker automatiquement les changements de page (navigation).
 * Utilise useLocation de React Router pour détecter les transitions.
 */
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '../services/tracking'

export function usePageTracking() {
  const location = useLocation()
  const prevPath = useRef(null)

  useEffect(() => {
    // Éviter le double-fire en StrictMode
    if (prevPath.current === location.pathname) return
    prevPath.current = location.pathname

    // Ne pas tracker les pages admin
    if (location.pathname.startsWith('/admin')) return

    trackEvent('page.view', {
      path: location.pathname,
      search: location.search,
    }, { page: location.pathname })
  }, [location.pathname, location.search])
}
